import React from 'react';
import _ from 'lodash';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useLocation } from 'react-use';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCogs, faFile, faFileAlt, faSignOut, faUser } from '@fortawesome/pro-duotone-svg-icons';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Avatar, Dropdown, Menu } from 'antd';
import Logo from '../logo/Logo';
import { menuSideBarAtom, userAtom, tokenAtom, userPrivilagesAtom, userOrganizationsAtom } from '../../../atoms/Atoms';
import LanguagePicker from '../language-picker/LanguagePicker';
import envConfig from '../../../envConfig';
import './header.css';  

function Header() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [user, setUser] = useRecoilState(userAtom);
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const userOrganizations = useRecoilValue(userOrganizationsAtom);
  const setToken = useSetRecoilState(tokenAtom);
  const [isMenuOpen, setIsMenuOpen] = useRecoilState(menuSideBarAtom);
  const hideMenu = false;
  const showLogo = true;

  function signOut() {
    const promise = new Promise(function (resolve, reject) {
      setIsMenuOpen(false);
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-user`);
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-token`);
      setToken(null);
      resolve();
    });
    promise.then(() => {
      setUser(null);
    })
    .then(() => {
      history.push('/');
    });
  }

  return ( 
    <header className="bg-white text-headerText h-24 py-2 px-4 lg:px-52 xl:px-72">
      <div className="flex w-full">
        <Logo
          className="h-20 py-4 hover:scale-110"
        />
        <div className="ml-auto flex divider-x space-x-4">
          <LanguagePicker className="mt-4" />
        </div>
      </div>
    </header>
  )
} 

export default Header;
